import { fetchMethod, postMethod } from "./http.api";

const SHAREFILE_TEST_BASE_URL = process.env.REACT_APP_SHAREFILE_BASE_URL || '';


const UploadService = {
    getUploads: async (folderId: string, token?: string) => {
        const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/get-files/${folderId}`;
        const headers = {
            'accept': "*/*",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
        return await fetchMethod(url, { headers })
    },

    addUploads: async (file: File, folderPath: string) => {
        const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/upload-file-by-folderId?folderId=${folderPath}`;
        const headers = {
            'FileName': file.name,
        };
        return postMethod(url, file, { headers })
    }
};


export default UploadService;